import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';
import type { ChiTietPhieuNhapKho } from '@/types/schemas';
import { calculateTotals } from '../../utils';
import { FormFieldState } from '../../hooks';

interface BottomBarProps {
  detailRows: ChiTietPhieuNhapKho[];
  state: FormFieldState;
}

export function BottomBar({ detailRows, state }: BottomBarProps) {
  const totals = calculateTotals(detailRows);

  const columns: SummaryColumn[] = [
    {
      className: 'min-w-[180px]',
      fields: [{ name: 't_so_luong', label: 'Tổng số lượng', value: totals.t_so_luong, precision: 6 }]
    },
    {
      className: 'min-w-[240px]',
      fields: [{ name: 't_tien_nt', label: 'Tổng tiền', value: totals.t_tien_nt, inputClassName: 'text-right' }]
    }
  ];

  return <BottomSummaryBarV2 columns={columns} />;
}

export default BottomBar;
